import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=3e4d8390&scoped=true&lang=pug&"
import script from "./overlay.vue?vue&type=script&lang=js&"
export * from "./overlay.vue?vue&type=script&lang=js&"
import style0 from "./overlay.vue?vue&type=style&index=0&id=3e4d8390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d8390",
  null
  
)

component.options.__file = "overlay.vue"
export default component.exports